import { ResourceType } from '@app/core/model/resource-type';

/**
 * Context-aware UI wording for the shared requeue flow, used by both the runs "Requeue -> Planned Run"
 * action and the ICA "Requeue -> Analysis" action. The sample sheet always physically lives on a run,
 * but the phrasing differs by which flow the user launched from: on the runs page it reads "this run";
 * from an analysis it references the analysis's input run. The context is expressed with the existing
 * ResourceType enum (RUN vs ANALYSIS) so callers pass a meaningful intent rather than raw display
 * strings, keeping a single source of truth for all requeue label wording (BASE-89231).
 */
export class RequeueAnalysisLabels {
    /** Phrase referring to the run the sample sheet comes from, e.g. "Sample sheet from {this run} is not found." */
    static readonly SOURCE_RUN_LABEL = (context: ResourceType): string =>
        context === ResourceType.ANALYSIS ? 'this analysis input run' : 'this run';

    /** Radio label for using the source run's existing sample sheet. */
    static readonly USE_EXISTING_SAMPLE_SHEET_LABEL = (context: ResourceType): string =>
        `Use Sample Sheet from ${RequeueAnalysisLabels.SOURCE_RUN_LABEL(context)}`;
}
